import { feishu, sessionKey } from '@/util/config';
import * as u from '@/util/util';
import { router } from './index.js';

var whiteList = ['/link'];

//获取路由树
function getRouter() {
  let tree = u.getSession(sessionKey.SYS_MENU_TREE);
  return buildRouterList(tree);
}

//构建路由集合
function buildRouterList(tree) {
  let routerList = [];
  tree.forEach(x => {
    if (x.children && x.children.length > 0) {
      routerList = routerList.concat(buildRouterList(x.children));
    }
    const component = 'view' + x.path.replace(/\/:.*$/, '');

    if (x.type == '1') {
      routerList.push({
        path: x.path,
        name: x.name,
        meta: {
          title: x.name,
          keepAlive: x.cache == 'Y' ? true : false
        },
        component(resolve) {
          require([`../${component}.vue`], resolve);
        }
      });
    }
  });
  return routerList;
}

//  拦截
var intercept = false; // 页面刷新货初次加载 才会执行这个变量

// 单点登录处理函数
async function handleSSOLogin(code, next) {
  try {
    const redirectUri = feishu.getRedirectUri();

    // 调用单点登录接口
    const response = await fetch(
      `/api/background/feishu/login?code=${code}&appId=${
        feishu.clientId
      }&redirectUrl=${encodeURIComponent(redirectUri)}`,
      {
        method: 'POST'
      }
    );

    const result = await response.json();

    if (result.code === 200 || result.code === 1) {
      // 单点登录成功，存储用户信息
      u.setLoginInfo(result.data);
      // 清除URL中的code参数
      window.history.replaceState({}, '', window.location.pathname);
      // 跳转到首页
      next('/sy');
    } else {
      // 登录失败，跳转到授权页面
      window.location.href = feishu.getAuthUrl();
    }
  } catch (error) {
    console.error('登录失败:', error);
  }
}

/*路由守卫*/
router.beforeEach(async (to, from, next) => {
  // 白名单路径，跳过认证检查
  if (whiteList.includes(to.path)) {
    if (to.path == '/link') {
      const targetUrl = `https://aftersales.creality.com/t/creality/?mainNavName=xrm#/vform2/incident/288a0037-0aa8-c03b-0000-059ceb48d090/${to.query.caseId}`;
      window.location.href = targetUrl;
      return;
    }
    next();
    return;
  }

  const token = u.getToken();

  document.title = to.meta.title;

  const url = new URL(window.location.href);
  const code = url.searchParams.get('code');

  // 检查URL中是否有code参数
  if (code) {
    await handleSSOLogin(code, next);
    return; // 重要：处理完code后直接返回
  }
  console.log(token, 'token');

  // 根路径处理和/login路径处理
  if (to.path === '/' || to.path === '' || to.path === '/login') {
    if (token == null || token == '') {
      window.location.href = feishu.getAuthUrl();
      return;
    } else {
      next('/sy');
      return;
    }
  }

  if (token == null || token == '') {
    window.location.href = feishu.getAuthUrl();
    return;
  }

  // 设置动态路由
  // 当 intercept 为false 表示 刷新了 或 第一次加载
  if (!intercept) {
    intercept = true; // 先让他变 true 不然跳转页面时会死循环

    getRouter().forEach(x => {
      const component = 'view' + x.path.replace(/\/:.*$/, '');
      router.options.routes[0].children.push({
        path: x.path,
        name: x.name,
        meta: x.meta,
        component(resolve) {
          require([`../${component}.vue`], resolve);
        }
      });
    });
    router.addRoutes(router.options.routes);
    next(to.path);
  } else {
    next();
  }
});
export default router;
